/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation
} from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType
} from '@tanstack/vue-query';

import {
  toValue
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  AiSkill,
  AiSkillRequestInput,
  SchemaValidationErrorResponse,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../internalAxiosClient.ts';
import type { ErrorType } from '../../../internalAxiosClient.ts';




/**
 * @summary Create AI Assistant Skill
 */
export const createAssistantSkill = (
    assistantId: MaybeRefOrGetter<string>,
    aiSkillRequestInput: MaybeRefOrGetter<AiSkillRequestInput>,
 signal?: AbortSignal
) => {
      assistantId = toValue(assistantId);
aiSkillRequestInput = toValue(aiSkillRequestInput);

      return axiosClient<AiSkill>(
      {url: `/ai/assistants/${assistantId}/skills`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: aiSkillRequestInput, signal
    },
      );
    }




export const getCreateAssistantSkillMutationKey = () => ['createAssistantSkill'] as const;

export const getCreateAssistantSkillMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAssistantSkill>>, TError,CreateAssistantSkillMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createAssistantSkill>>, TError,CreateAssistantSkillMutationVariables, TContext> => {

const mutationKey = getCreateAssistantSkillMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAssistantSkill>>, CreateAssistantSkillMutationVariables> = (props) => {
          const {assistantId,data} = props ?? {};

          return  createAssistantSkill(assistantId,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAssistantSkillMutationResult = NonNullable<Awaited<ReturnType<typeof createAssistantSkill>>>
    export type CreateAssistantSkillMutationBody = AiSkillRequestInput
    export type CreateAssistantSkillMutationError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>
    export type CreateAssistantSkillMutationVariables = {assistantId: string;data: AiSkillRequestInput}

    /**
 * @summary Create AI Assistant Skill
 */
export const useCreateAssistantSkill = <TError = ErrorType<SchemaValidationErrorResponse | void | ValidationError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAssistantSkill>>, TError,CreateAssistantSkillMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createAssistantSkill>>,
        TError,
        CreateAssistantSkillMutationVariables,
        TContext
      > => {
      return useMutation(getCreateAssistantSkillMutationOptions(options), queryClient);
    }
    /**
 * @summary Delete AI Assistant Skill
 */
export const deleteAssistantSkill = (
    assistantId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      assistantId = toValue(assistantId);
id = toValue(id);

      return axiosClient<void>(
      {url: `/ai/assistants/${assistantId}/skills/${id}`, method: 'DELETE', signal
    },
      );
    }




export const getDeleteAssistantSkillMutationKey = () => ['deleteAssistantSkill'] as const;

export const getDeleteAssistantSkillMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAssistantSkill>>, TError,DeleteAssistantSkillMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteAssistantSkill>>, TError,DeleteAssistantSkillMutationVariables, TContext> => {

const mutationKey = getDeleteAssistantSkillMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteAssistantSkill>>, DeleteAssistantSkillMutationVariables> = (props) => {
          const {assistantId,id} = props ?? {};

          return  deleteAssistantSkill(assistantId,id,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteAssistantSkillMutationResult = NonNullable<Awaited<ReturnType<typeof deleteAssistantSkill>>>

    export type DeleteAssistantSkillMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type DeleteAssistantSkillMutationVariables = {assistantId: string;id: string}

    /**
 * @summary Delete AI Assistant Skill
 */
export const useDeleteAssistantSkill = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteAssistantSkill>>, TError,DeleteAssistantSkillMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof deleteAssistantSkill>>,
        TError,
        DeleteAssistantSkillMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteAssistantSkillMutationOptions(options), queryClient);
    }
    /**
 * @summary Replace the file of an AI Assistant Skill
 */
export const updateAssistantSkill = (
    assistantId: MaybeRefOrGetter<string>,
    id: MaybeRefOrGetter<string>,
    aiSkillRequestInput: MaybeRefOrGetter<AiSkillRequestInput>,
 signal?: AbortSignal
) => {
      assistantId = toValue(assistantId);
id = toValue(id);
aiSkillRequestInput = toValue(aiSkillRequestInput);

      return axiosClient<AiSkill>(
      {url: `/ai/assistants/${assistantId}/skills/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: aiSkillRequestInput, signal
    },
      );
    }




export const getUpdateAssistantSkillMutationKey = () => ['updateAssistantSkill'] as const;

export const getUpdateAssistantSkillMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAssistantSkill>>, TError,UpdateAssistantSkillMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateAssistantSkill>>, TError,UpdateAssistantSkillMutationVariables, TContext> => {

const mutationKey = getUpdateAssistantSkillMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAssistantSkill>>, UpdateAssistantSkillMutationVariables> = (props) => {
          const {assistantId,id,data} = props ?? {};

          return  updateAssistantSkill(assistantId,id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateAssistantSkillMutationResult = NonNullable<Awaited<ReturnType<typeof updateAssistantSkill>>>
    export type UpdateAssistantSkillMutationBody = AiSkillRequestInput
    export type UpdateAssistantSkillMutationError = ErrorType<SchemaValidationErrorResponse | void>
    export type UpdateAssistantSkillMutationVariables = {assistantId: string;id: string;data: AiSkillRequestInput}

    /**
 * @summary Replace the file of an AI Assistant Skill
 */
export const useUpdateAssistantSkill = <TError = ErrorType<SchemaValidationErrorResponse | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAssistantSkill>>, TError,UpdateAssistantSkillMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateAssistantSkill>>,
        TError,
        UpdateAssistantSkillMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateAssistantSkillMutationOptions(options), queryClient);
    }
